"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.semanticLightColorValues = void 0;
const color_1 = require("../../typings/color");
const semanticLightColorValues = {
    $actionIcon100: color_1.paletteColorValues.$primary300,
    $background100: color_1.paletteColorValues.$tertiary100,
    $background200: color_1.paletteColorValues.$tertiary100,
    $background300: color_1.paletteColorValues.$primary300,
    $content100: color_1.paletteColorValues.$primary300,
    $content200: color_1.paletteColorValues.$neutral600,
    $content300: color_1.paletteColorValues.$neutral100,
    $inputPrimaryDefault: color_1.paletteColorValues.$primary300,
    $inputPrimaryDisabled: color_1.paletteColorValues.$tertiary200,
    $inputPrimaryError: color_1.paletteColorValues.$error400,
    $inputPrimaryHover: color_1.paletteColorValues.$primary100,
    $interactiveLinkDefault: color_1.paletteColorValues.$secondary300,
    $interactiveLinkDisabled: color_1.paletteColorValues.$neutral400,
    $interactiveLinkHover: color_1.paletteColorValues.$secondary200,
    $interactiveLinkPressed: color_1.paletteColorValues.$secondary500,
    $interactivePrimaryDefault: color_1.paletteColorValues.$primary300,
    $interactivePrimaryDisabled: color_1.paletteColorValues.$neutral400,
    $interactivePrimaryHover: color_1.paletteColorValues.$primary200,
    $interactivePrimaryPressed: color_1.paletteColorValues.$primary400,
    $staticIcon100: color_1.paletteColorValues.$primary300,
};
exports.semanticLightColorValues = semanticLightColorValues;
